(function () {
  'use strict';

  if (window.__VSKLO_PREMIUM_PRODUCT_HERO_GALLERY__) return;
  window.__VSKLO_PREMIUM_PRODUCT_HERO_GALLERY__ = true;

  var premiumHeroControllers = new Set();

  function money(cents) {
    if (typeof window.vskloFormatMoney === 'function') {
      return window.vskloFormatMoney(cents);
    }
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var format = window.themeGlobalVariables && window.themeGlobalVariables.settings
        ? window.themeGlobalVariables.settings.money_format
        : undefined;
      return window.Shopify.formatMoney(cents, format);
    }
    var amount = Number(cents || 0) / 100;
    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    if (currency && window.Intl && Intl.NumberFormat) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: currency
        }).format(amount);
      } catch (error) {}
    }
    return amount.toLocaleString(document.documentElement.lang || undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function initHero(root) {
    if (!root || root.dataset.vphReady === 'true') return;

    var json = root.querySelector('[data-vph-variants]');
    var variants = [];
    try { variants = JSON.parse(json && json.textContent || '[]'); } catch (error) {}

    var optionGroups = Array.from(root.querySelectorAll('[data-vph-option-position]'));
    var variantInput = root.querySelector('[data-vph-variant-id]');
    var price = root.querySelector('[data-vph-price]');
    var compare = root.querySelector('[data-vph-compare]');
    var availability = root.querySelector('[data-vph-availability]');
    var availabilityText = root.querySelector('[data-vph-availability-text]');
    var addButton = root.querySelector('[data-vph-add-button]');
    var addLabel = root.querySelector('[data-vph-add-label]');
    var strings = window.vskloStrings && window.vskloStrings.addonsPopup || {};
    var initialInStock = availability && availability.dataset.vphInStock || strings.inStock || '';
    var outOfStock = availability && availability.dataset.vphOutOfStock || strings.outOfStock || '';
    var defaultAddLabel = addLabel && addLabel.textContent.trim();
    var marketUnavailable = Boolean(addButton && addButton.dataset.vskloMarketUnavailable === 'true');
    var marketUnavailableLabel =
      addButton && addButton.dataset.marketUnavailableLabel
        ? addButton.dataset.marketUnavailableLabel
        : defaultAddLabel;

    var stage = root.querySelector('[data-vph-stage]');
    var mediaItems = Array.from(root.querySelectorAll('[data-vph-media-id]'));
    var counter = root.querySelector('[data-vph-counter]');
    var thumbsTrack = root.querySelector('[data-vph-thumbs]');
    var thumbsPrevious = root.querySelector('[data-vph-thumbs-prev]');
    var thumbsNext = root.querySelector('[data-vph-thumbs-next]');
    var loop = root.dataset.galleryLoop !== 'false';
    var currentIndex = Math.max(0, mediaItems.findIndex(function (item) { return item.classList.contains('is-active'); }));
    var touchStartX = null;
    var lastFocus = null;

    var lightbox = root.querySelector('[data-vph-lightbox]');
    var lightboxImage = lightbox && lightbox.querySelector('[data-vph-lightbox-image]');
    var lightboxCounter = lightbox && lightbox.querySelector('[data-vph-lightbox-counter]');
    var imageItems = mediaItems.filter(function (item) { return item.dataset.vphMediaType === 'image'; });
    var lightboxIndex = 0;
    var lightboxScale = 1;
    var lightboxX = 0;
    var lightboxY = 0;
    var lightboxTouchStart = null;
    var lightboxPanStart = null;
    var lightboxPinchStart = null;
    var lightboxDidPinch = false;
    var lightboxGestureActive = false;
    var lightboxGestureMoved = false;
    var lightboxSuppressClickUntil = 0;
    var bodyScrollY = 0;
    var bodyScrollStyles = null;

    function lockPremiumPageScroll() {
      if (bodyScrollStyles) return;
      bodyScrollY = window.scrollY || window.pageYOffset || 0;
      bodyScrollStyles = {};
      ['position', 'top', 'left', 'right', 'width'].forEach(function (property) {
        bodyScrollStyles[property] = {
          value: document.body.style.getPropertyValue(property),
          priority: document.body.style.getPropertyPriority(property)
        };
      });
      document.body.style.setProperty('position', 'fixed');
      document.body.style.setProperty('top', '-' + bodyScrollY + 'px');
      document.body.style.setProperty('left', '0');
      document.body.style.setProperty('right', '0');
      document.body.style.setProperty('width', '100%');
    }

    function unlockPremiumPageScroll() {
      if (!bodyScrollStyles) return;
      ['position', 'top', 'left', 'right', 'width'].forEach(function (property) {
        var original = bodyScrollStyles[property];
        if (original && original.value) {
          document.body.style.setProperty(property, original.value, original.priority);
        } else {
          document.body.style.removeProperty(property);
        }
      });
      bodyScrollStyles = null;
      window.scrollTo(0, bodyScrollY);
    }

    // Preserve the initial hero preload; fetch later frames progressively.
    var stageLoadToken = 0;
    var stageLoaderTimer = 0;
    var fullLoadToken = 0;
    var fullLoaderTimer = 0;
    var fullImageCache = new Map();
    var fullViewport = lightbox && lightbox.querySelector('.vsklo-premium-lightbox__viewport');

    function avoidsBackgroundPrefetch() {
      var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      return Boolean(connection && (connection.saveData || /^(slow-2g|2g)$/.test(connection.effectiveType || '')));
    }

    function scheduleIdle(task, delay) {
      if ('requestIdleCallback' in window) window.requestIdleCallback(task, { timeout: 1800 });
      else window.setTimeout(task, delay || 400);
    }

    function syncStageLoading(item) {
      var token = ++stageLoadToken;
      window.clearTimeout(stageLoaderTimer);
      if (stage) stage.classList.remove('is-media-loading');
      if (!stage || !item || item.dataset.vphMediaType !== 'image') return;
      var image = item.querySelector('img');
      if (!image) return;
      image.loading = 'eager';
      if ('fetchPriority' in image) image.fetchPriority = 'high';
      function warmNext() {
        if (avoidsBackgroundPrefetch() || mediaItems.length < 2) return;
        var index = currentIndex;
        scheduleIdle(function () {
          if (token !== stageLoadToken || !root.isConnected) return;
          var next = mediaItems[normalizedIndex(index + 1, mediaItems.length)];
          if (!next || next === item || next.dataset.vphMediaType !== 'image') return;
          var sibling = next.querySelector('img');
          if (!sibling || sibling.complete) return;
          sibling.loading = 'eager';
          if ('fetchPriority' in sibling) sibling.fetchPriority = 'low';
          if (typeof sibling.decode === 'function') sibling.decode().catch(function () {});
        }, 450);
      }
      if (image.complete) { if (image.naturalWidth > 0) warmNext(); return; }
      stageLoaderTimer = window.setTimeout(function () {
        if (token === stageLoadToken && !image.complete) stage.classList.add('is-media-loading');
      }, 120);
      var finish = function () {
        if (token !== stageLoadToken) return;
        window.clearTimeout(stageLoaderTimer);
        stage.classList.remove('is-media-loading');
        if (image.naturalWidth > 0) warmNext();
      };
      image.addEventListener('load', finish, { once: true });
      image.addEventListener('error', finish, { once: true });
    }

    function setFullscreenBusy(busy, token) {
      if (!lightbox || token !== fullLoadToken) return;
      window.clearTimeout(fullLoaderTimer);
      lightbox.classList.remove('is-image-loading');
      if (fullViewport) fullViewport.setAttribute('aria-busy', busy ? 'true' : 'false');
      if (busy) {
        fullLoaderTimer = window.setTimeout(function () {
          if (token === fullLoadToken && lightbox.classList.contains('is-open')) {
            lightbox.classList.add('is-image-loading');
          }
        }, 110);
      }
    }

    function primeFullImage(src, priority) {
      if (!src) return null;
      var cached = fullImageCache.get(src);
      if (cached) {
        if (priority === 'high' && 'fetchPriority' in cached.image) cached.image.fetchPriority = 'high';
        fullImageCache.delete(src);
        fullImageCache.set(src, cached);
        return cached;
      }
      var image = new Image();
      image.decoding = 'async';
      if ('fetchPriority' in image) image.fetchPriority = priority || 'low';
      var record = { image: image, ok: null, ready: null };
      record.ready = new Promise(function (resolve) {
        function onReady() {
          if (typeof image.decode !== 'function') { resolve(true); return; }
          try {
            image.decode().then(function () { resolve(true); }, function () { resolve(image.naturalWidth > 0); });
          } catch (error) { resolve(image.naturalWidth > 0); }
        }
        image.addEventListener('load', onReady, { once: true });
        image.addEventListener('error', function () { resolve(false); }, { once: true });
      }).then(function (ok) {
        record.ok = ok;
        if (!ok && fullImageCache.get(src) === record) fullImageCache.delete(src);
        return ok;
      });
      image.src = src;
      fullImageCache.set(src, record);
      while (fullImageCache.size > 5) fullImageCache.delete(fullImageCache.keys().next().value);
      return record;
    }

    function warmFullNeighbor(index, token) {
      if (avoidsBackgroundPrefetch() || imageItems.length < 2) return;
      var target = normalizedIndex(index + 1, imageItems.length);
      if (target === index) return;
      scheduleIdle(function () {
        if (token !== fullLoadToken || !root.isConnected || !lightbox ||
            !lightbox.classList.contains('is-open') || lightboxIndex !== index) return;
        primeFullImage(imageItems[target].dataset.vphFullSrc, 'low');
      }, 450);
    }

    if (lightbox && lightbox.parentElement !== document.body) document.body.appendChild(lightbox);

    function normalizedIndex(index, length) {
      if (!length) return 0;
      if (loop) return (index + length) % length;
      return Math.max(0, Math.min(length - 1, index));
    }

    function updateGalleryControls() {
      if (counter) counter.textContent = (currentIndex + 1) + ' / ' + mediaItems.length;
      var previous = root.querySelector('[data-vph-prev]');
      var next = root.querySelector('[data-vph-next]');
      if (!loop && previous) previous.disabled = currentIndex === 0;
      if (!loop && next) next.disabled = currentIndex === mediaItems.length - 1;
    }

    function updateThumbControls() {
      if (!thumbsTrack) return;
      var maxScroll = Math.max(0, thumbsTrack.scrollWidth - thumbsTrack.clientWidth);
      if (thumbsPrevious) thumbsPrevious.disabled = thumbsTrack.scrollLeft <= 2;
      if (thumbsNext) thumbsNext.disabled = thumbsTrack.scrollLeft >= maxScroll - 2;
    }

    function centerThumb(thumb) {
      if (!thumbsTrack || !thumb) return;
      var trackRect = thumbsTrack.getBoundingClientRect();
      var thumbRect = thumb.getBoundingClientRect();
      var target = thumbsTrack.scrollLeft
        + (thumbRect.left - trackRect.left)
        - (thumbsTrack.clientWidth - thumbRect.width) / 2;
      var maxScroll = Math.max(0, thumbsTrack.scrollWidth - thumbsTrack.clientWidth);
      thumbsTrack.scrollTo({ left: Math.max(0, Math.min(maxScroll, target)), behavior: 'smooth' });
    }

    function scrollThumbs(direction) {
      if (!thumbsTrack) return;
      thumbsTrack.scrollBy({
        left: direction * Math.max(120, thumbsTrack.clientWidth * .75),
        behavior: 'smooth'
      });
    }

    function showMedia(id, shouldFocus) {
      if (!id || !mediaItems.length) return;
      var nextIndex = mediaItems.findIndex(function (item) { return String(item.dataset.vphMediaId) === String(id); });
      if (nextIndex < 0) return;
      currentIndex = nextIndex;

      mediaItems.forEach(function (item, index) {
        var active = index === currentIndex;
        item.hidden = !active;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-hidden', active ? 'false' : 'true');
        item.querySelectorAll('video').forEach(function (video) { if (!active) video.pause(); });
      });

      root.querySelectorAll('[data-vph-thumb]').forEach(function (thumb) {
        var active = String(thumb.dataset.vphThumb) === String(id);
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
        if (active) centerThumb(thumb);
      });

      updateGalleryControls();
      syncStageLoading(mediaItems[currentIndex]);
      if (shouldFocus && stage) stage.focus({ preventScroll: true });
    }

    function moveMedia(direction) {
      if (mediaItems.length < 2) return;
      var nextIndex = normalizedIndex(currentIndex + direction, mediaItems.length);
      if (nextIndex === currentIndex && !loop) return;
      showMedia(mediaItems[nextIndex].dataset.vphMediaId);
    }

    function showLightboxImage(index) {
      if (!lightboxImage || !imageItems.length) return;
      resetLightboxTransform();
      var token = ++fullLoadToken;
      lightboxIndex = normalizedIndex(index, imageItems.length);
      var item = imageItems[lightboxIndex];
      var src = item.dataset.vphFullSrc || '';
      var sourceImage = item.querySelector('img');
      var preview = sourceImage && sourceImage.complete && sourceImage.naturalWidth > 0
        ? (sourceImage.currentSrc || sourceImage.src || '')
        : '';
      lightboxImage.alt = sourceImage ? sourceImage.alt : '';
      if (lightboxCounter) lightboxCounter.textContent = (lightboxIndex + 1) + ' / ' + imageItems.length;
      var record = primeFullImage(src, 'high');
      if (record && record.ok === true) {
        lightboxImage.src = src;
        setFullscreenBusy(false, token);
        warmFullNeighbor(lightboxIndex, token);
        return;
      }
      if (preview) lightboxImage.src = preview;
      else lightboxImage.removeAttribute('src');
      if (!record) { setFullscreenBusy(false, token); return; }
      setFullscreenBusy(true, token);
      record.ready.then(function (ok) {
        if (token !== fullLoadToken || !lightbox || !lightbox.classList.contains('is-open')) return;
        if (ok) lightboxImage.src = src;
        setFullscreenBusy(false, token);
        if (ok) warmFullNeighbor(lightboxIndex, token);
      });
    }

    function positionMobileLightboxClose() {
      if (!lightbox || window.innerWidth > 749) {
        if (lightbox) lightbox.style.removeProperty('--vph-lightbox-close-top');
        return;
      }

      var headerBottom = 0;
      var candidates = document.querySelectorAll('header, .section-header, .shopify-section-group-header-group, [id*="shopify-section-header"]');
      candidates.forEach(function (candidate) {
        var rect = candidate.getBoundingClientRect();
        var style = window.getComputedStyle(candidate);
        if (style.display === 'none' || style.visibility === 'hidden') return;
        if (rect.width < 100 || rect.height <= 0 || rect.height > 220) return;
        if (rect.top <= 12 && rect.bottom > 0 && rect.bottom < window.innerHeight * .45) {
          headerBottom = Math.max(headerBottom, rect.bottom);
        }
      });

      lightbox.style.setProperty('--vph-lightbox-close-top', Math.round(headerBottom + 12) + 'px');
    }

    function clamp(value, min, max) {
      return Math.max(min, Math.min(max, value));
    }

    function touchDistance(first, second) {
      var x = second.clientX - first.clientX;
      var y = second.clientY - first.clientY;
      return Math.sqrt(x * x + y * y);
    }

    function applyLightboxTransform() {
      if (!lightboxImage) return;
      if (lightboxScale <= 1) {
        lightboxScale = 1;
        lightboxX = 0;
        lightboxY = 0;
      }
      lightboxImage.style.transform = 'translate3d(' + lightboxX + 'px,' + lightboxY + 'px,0) scale(' + lightboxScale + ')';
      lightbox.classList.toggle('is-zoomed', lightboxScale > 1);
    }

    function resetLightboxTransform() {
      lightboxScale = 1;
      lightboxX = 0;
      lightboxY = 0;
      lightboxTouchStart = null;
      lightboxPanStart = null;
      lightboxPinchStart = null;
      lightboxDidPinch = false;
      if (lightboxImage) lightboxImage.style.transform = '';
      if (lightbox) lightbox.classList.remove('is-zoomed', 'is-gesturing');
    }

    function openLightbox(item, opener) {
      if (!lightbox || !item || item.dataset.vphMediaType !== 'image') return;
      var nextIndex = Math.max(0, imageItems.indexOf(item));
      if (lightbox.classList.contains('is-open')) {
        showLightboxImage(nextIndex);
        return;
      }
      lastFocus = opener || document.activeElement;
      lightboxSuppressClickUntil = 0;
      lightboxGestureMoved = false;
      lightboxGestureActive = false;
      positionMobileLightboxClose();
      lightbox.removeAttribute('inert');
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('vsklo-premium-lightbox-open');
      document.body.classList.add('vsklo-premium-lightbox-open');
      lockPremiumPageScroll();
      if (window.VSKLOOverlayState) window.VSKLOOverlayState.acquire('pdp-lightbox');
      showLightboxImage(nextIndex);
      var close = lightbox.querySelector('[data-vph-lightbox-close]');
      if (close) close.focus({ preventScroll: true });
    }

    function closeLightbox() {
      if (!lightbox || !lightbox.classList.contains('is-open')) return;
      ++fullLoadToken;
      setFullscreenBusy(false, fullLoadToken);
      lightboxGestureActive = false;
      lightboxGestureMoved = false;
      resetLightboxTransform();
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      lightbox.setAttribute('inert', '');
      document.documentElement.classList.remove('vsklo-premium-lightbox-open');
      document.body.classList.remove('vsklo-premium-lightbox-open');
      if (window.VSKLOOverlayState) window.VSKLOOverlayState.release('pdp-lightbox');
      if (lightboxImage) lightboxImage.removeAttribute('src');
      unlockPremiumPageScroll();
      var restore = lastFocus;
      lastFocus = null;
      if (restore && restore.isConnected && typeof restore.focus === 'function') {
        try { restore.focus({ preventScroll: true }); } catch (error) { restore.focus(); }
      }
    }

    if (lightbox) lightbox.__vskloPremiumClose = closeLightbox;

    function selectedOptions() {
      return optionGroups.map(function (group) {
        var checked = group.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant() {
      var options = selectedOptions();
      return variants.find(function (variant) {
        return variant.options.every(function (value, index) { return value === options[index]; });
      });
    }

    function updateOptionAvailability() {
      optionGroups.forEach(function (group, groupIndex) {
        group.querySelectorAll('input[type="radio"]').forEach(function (input) {
          var values = selectedOptions();
          values[groupIndex] = input.value;
          input.disabled = !variants.some(function (variant) {
            return variant.available && variant.options.every(function (value, index) {
              return index === groupIndex ? value === input.value : !values[index] || value === values[index];
            });
          });
        });
      });
    }

    function updateVariant() {
      var variant = findVariant();
      optionGroups.forEach(function (group) {
        var checked = group.querySelector('input:checked');
        var label = group.querySelector('[data-vph-option-label]');
        if (checked && label) label.textContent = checked.value;
      });
      updateOptionAvailability();

      if (!variant) {
        if (addButton) addButton.disabled = true;
        if (availability) availability.classList.add('is-unavailable');
        if (availabilityText) availabilityText.textContent = outOfStock;
        return;
      }

      if (variantInput) {
        variantInput.value = variant.id;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (price) price.textContent = money(variant.price);
      if (compare) {
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        compare.textContent = onSale ? money(variant.compare_at_price) : '';
        compare.classList.toggle('is-hidden', !onSale);
      }
      if (availability) availability.classList.toggle('is-unavailable', !variant.available);
      if (availabilityText) availabilityText.textContent = variant.available ? initialInStock : outOfStock;
      if (addButton) {
        var purchaseDisabled = marketUnavailable || !variant.available;
        addButton.disabled = purchaseDisabled;
        addButton.setAttribute('aria-disabled', purchaseDisabled ? 'true' : 'false');
      }
      if (addLabel && (!addButton || !addButton.classList.contains('js-open-addons-popup'))) {
        addLabel.textContent = marketUnavailable
          ? marketUnavailableLabel
          : (variant.available ? defaultAddLabel : outOfStock);
      }
      if (variant.featured_media && variant.featured_media.id) showMedia(variant.featured_media.id);

      if (root.dataset.updateUrl === 'true') {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      root.dispatchEvent(new CustomEvent('vsklo:variant:change', { bubbles: true, detail: { variant: variant } }));
    }

    root.addEventListener('change', function (event) {
      if (event.target.closest('[data-vph-options]')) updateVariant();
    });

    root.addEventListener('click', function (event) {
      var thumb = event.target.closest('[data-vph-thumb]');
      if (thumb && root.contains(thumb)) { showMedia(thumb.dataset.vphThumb); return; }
      if (event.target.closest('[data-vph-prev]')) { moveMedia(-1); return; }
      if (event.target.closest('[data-vph-next]')) { moveMedia(1); return; }
      if (event.target.closest('[data-vph-thumbs-prev]')) { scrollThumbs(-1); return; }
      if (event.target.closest('[data-vph-thumbs-next]')) { scrollThumbs(1); return; }
      var opener = event.target.closest('[data-vph-open-lightbox]');
      if (opener) openLightbox(opener.closest('[data-vph-media-id]'), opener);
    });

    if (stage) {
      stage.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') { event.preventDefault(); moveMedia(-1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); moveMedia(1); }
      });
      stage.addEventListener('touchstart', function (event) { touchStartX = event.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (event) {
        if (touchStartX === null) return;
        var distance = event.changedTouches[0].clientX - touchStartX;
        touchStartX = null;
        if (Math.abs(distance) > 45) moveMedia(distance > 0 ? -1 : 1);
      }, { passive: true });
    }

    if (thumbsTrack) {
      thumbsTrack.addEventListener('scroll', updateThumbControls, { passive: true });
      thumbsTrack.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') { event.preventDefault(); scrollThumbs(-1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); scrollThumbs(1); }
      });
      window.addEventListener('resize', updateThumbControls, { passive: true });
    }

    if (lightbox) {
      window.addEventListener('resize', positionMobileLightboxClose, { passive: true });
      lightbox.addEventListener('click', function (event) {
        // Explicit controls always work; suppress only the synthetic backdrop
        // click that some mobile browsers dispatch after a completed swipe.
        if (event.target.closest('[data-vph-lightbox-close]')) {
          closeLightbox();
        } else if (event.target.closest('[data-vph-lightbox-prev]')) {
          showLightboxImage(lightboxIndex - 1);
        } else if (event.target.closest('[data-vph-lightbox-next]')) {
          showLightboxImage(lightboxIndex + 1);
        } else if (Date.now() >= lightboxSuppressClickUntil &&
            (event.target === lightbox ||
             (event.target === fullViewport && lightboxScale <= 1))) {
          closeLightbox();
        }
      });
      lightbox.addEventListener('keydown', function (event) {
        if (!lightbox.classList.contains('is-open')) return;
        if (event.key === 'Tab') {
          // Keep the active dialog keyboard-modal without preventing native
          // Tab navigation between its visible close and gallery actions.
          var focusables = Array.from(lightbox.querySelectorAll(
            'a[href], button:not(:disabled), input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex]:not([tabindex="-1"])'
          )).filter(function (element) {
            return !element.hidden && element.getClientRects().length > 0 &&
              window.getComputedStyle(element).visibility !== 'hidden';
          });
          if (!focusables.length) {
            event.preventDefault();
            lightbox.setAttribute('tabindex', '-1');
            lightbox.focus();
            return;
          }
          var first = focusables[0];
          var last = focusables[focusables.length - 1];
          if (event.shiftKey && (document.activeElement === first || !lightbox.contains(document.activeElement))) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && (document.activeElement === last || !lightbox.contains(document.activeElement))) {
            event.preventDefault();
            first.focus();
          }
          return;
        }
        if (event.key === 'Escape') {
          event.preventDefault();
          closeLightbox();
          return;
        }
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          showLightboxImage(lightboxIndex - 1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          showLightboxImage(lightboxIndex + 1);
        }
      });

      lightbox.addEventListener('touchstart', function (event) {
        if (!lightbox.classList.contains('is-open') || !fullViewport ||
            !fullViewport.contains(event.target)) return;

        lightboxGestureActive = true;
        lightboxGestureMoved = false;
        lightbox.classList.add('is-gesturing');

        if (event.touches.length >= 2) {
          event.preventDefault();
          lightboxDidPinch = true;
          lightboxGestureMoved = true;
          lightboxPinchStart = {
            distance: touchDistance(event.touches[0], event.touches[1]),
            scale: lightboxScale
          };
          lightboxTouchStart = null;
          return;
        }

        if (event.touches.length === 1) {
          lightboxTouchStart = {
            x: event.touches[0].clientX,
            y: event.touches[0].clientY
          };
          lightboxPanStart = {
            x: event.touches[0].clientX,
            y: event.touches[0].clientY,
            translateX: lightboxX,
            translateY: lightboxY
          };
          lightboxDidPinch = false;
        }
      }, { passive: false });

      lightbox.addEventListener('touchmove', function (event) {
        if (!lightboxGestureActive || !lightbox.classList.contains('is-open')) return;
        if (event.touches.length >= 2 && lightboxPinchStart) {
          event.preventDefault();
          lightboxGestureMoved = true;
          lightboxDidPinch = true;
          var nextDistance = touchDistance(event.touches[0], event.touches[1]);
          lightboxScale = clamp(lightboxPinchStart.scale * nextDistance /
            Math.max(1, lightboxPinchStart.distance), 1, 4);
          applyLightboxTransform();
          return;
        }

        if (event.touches.length !== 1) return;
        if (lightboxScale > 1 && lightboxPanStart) {
          event.preventDefault();
          lightboxGestureMoved = true;
          lightboxX = lightboxPanStart.translateX + event.touches[0].clientX - lightboxPanStart.x;
          lightboxY = lightboxPanStart.translateY + event.touches[0].clientY - lightboxPanStart.y;
          applyLightboxTransform();
          return;
        }

        if (lightboxTouchStart) {
          var dx = event.touches[0].clientX - lightboxTouchStart.x;
          var dy = event.touches[0].clientY - lightboxTouchStart.y;
          if (Math.abs(dx) > 7 || Math.abs(dy) > 7) {
            event.preventDefault();
            lightboxGestureMoved = true;
          }
        }
      }, { passive: false });

      lightbox.addEventListener('touchend', function (event) {
        if (!lightboxGestureActive) return;
        if (event.touches.length === 1 && lightboxDidPinch) {
          lightboxPinchStart = null;
          lightboxPanStart = {
            x: event.touches[0].clientX,
            y: event.touches[0].clientY,
            translateX: lightboxX,
            translateY: lightboxY
          };
          return;
        }

        if (event.touches.length > 0) return;
        lightboxGestureActive = false;
        lightbox.classList.remove('is-gesturing');
        lightboxPinchStart = null;

        var touch = event.changedTouches[0];
        var deltaX = touch && lightboxTouchStart ? touch.clientX - lightboxTouchStart.x : 0;
        var deltaY = touch && lightboxTouchStart ? touch.clientY - lightboxTouchStart.y : 0;
        var didMove = lightboxGestureMoved || Math.abs(deltaX) > 7 || Math.abs(deltaY) > 7;
        if (didMove || lightboxDidPinch) lightboxSuppressClickUntil = Date.now() + 500;

        var wasPinch = lightboxDidPinch;
        var isUnzoomed = lightboxScale <= 1.01;
        lightboxTouchStart = null;
        lightboxPanStart = null;
        lightboxDidPinch = false;
        lightboxGestureMoved = false;

        if (!wasPinch && isUnzoomed && Math.abs(deltaX) > 45 &&
            Math.abs(deltaX) > Math.abs(deltaY) * 1.15) {
          showLightboxImage(lightboxIndex + (deltaX > 0 ? -1 : 1));
          return;
        }
        if (!wasPinch && isUnzoomed && deltaY > 100 &&
            deltaY > Math.abs(deltaX) * 1.3) {
          closeLightbox();
          return;
        }
        applyLightboxTransform();
      }, { passive: true });

      lightbox.addEventListener('touchcancel', function () {
        if (!lightboxGestureActive) return;
        lightboxGestureActive = false;
        lightboxGestureMoved = false;
        lightboxSuppressClickUntil = Date.now() + 500;
        lightbox.classList.remove('is-gesturing');
        lightboxTouchStart = null;
        lightboxPanStart = null;
        lightboxPinchStart = null;
        lightboxDidPinch = false;
        applyLightboxTransform();
      }, { passive: true });

      if (fullViewport) {
        fullViewport.addEventListener('dblclick', function (event) {
          if (!lightbox.classList.contains('is-open')) return;
          event.preventDefault();
          lightboxScale = lightboxScale > 1 ? 1 : 2;
          applyLightboxTransform();
        });
      }
    }

    var controller = {
      root: root,
      lightbox: lightbox,
      cleanup: null
    };

    controller.cleanup = function () {
      if (!premiumHeroControllers.has(controller)) return;
      premiumHeroControllers.delete(controller);
      ++stageLoadToken;
      ++fullLoadToken;
      window.clearTimeout(stageLoaderTimer);
      window.clearTimeout(fullLoaderTimer);
      if (stage) stage.classList.remove('is-media-loading');
      if (lightbox) lightbox.classList.remove('is-image-loading');
      fullImageCache.clear();

      window.removeEventListener('resize', updateThumbControls);
      window.removeEventListener('resize', positionMobileLightboxClose);

      if (lightbox && lightbox.classList.contains('is-open')) {
        try { closeLightbox(); } catch (error) {}
      }
      if (lightbox && lightbox.parentElement === document.body) lightbox.remove();

      root.removeAttribute('data-vph-ready');
      root.__vskloPremiumHeroController = null;
    };

    root.__vskloPremiumHeroController = controller;
    premiumHeroControllers.add(controller);

    updateOptionAvailability();
    if (mediaItems.length) showMedia(mediaItems[currentIndex].dataset.vphMediaId);
    window.requestAnimationFrame(updateThumbControls);
    root.dataset.vphReady = 'true';
  }

  function cleanupOrphanedPremiumHeroes() {
    Array.from(premiumHeroControllers).forEach(function (controller) {
      if (!controller || !controller.root || !controller.root.isConnected) {
        try { controller && controller.cleanup && controller.cleanup(); } catch (error) {}
      }
    });
  }

  function cleanupPremiumHeroesInScope(scope) {
    if (!scope) return;
    Array.from(premiumHeroControllers).forEach(function (controller) {
      var root = controller && controller.root;
      if (!root) return;
      if (root === scope || (scope.contains && scope.contains(root))) {
        try { controller.cleanup(); } catch (error) {}
      }
    });
  }

  function init(scope) {
    cleanupOrphanedPremiumHeroes();
    var target = scope && scope.querySelectorAll ? scope : document;
    if (target.matches && target.matches('[data-vsklo-premium-hero]')) initHero(target);
    target.querySelectorAll('[data-vsklo-premium-hero]').forEach(initHero);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    cleanupPremiumHeroesInScope(event && event.target ? event.target : null);
    var id = event.detail && event.detail.sectionId;
    document.querySelectorAll('body > [data-vph-lightbox][data-owner-section="' + id + '"]').forEach(function (node) {
      if (typeof node.__vskloPremiumClose === 'function') {
        try { node.__vskloPremiumClose(); } catch (error) {}
      }
      node.remove();
    });
  });
  document.addEventListener('vsklo:content-updated', function (event) {
    var detail = event && event.detail ? event.detail : {};
    var scope =
      (detail.root && detail.root.querySelectorAll && detail.root) ||
      (detail.scope && detail.scope.querySelectorAll && detail.scope) ||
      document;
    init(scope);
  });
  window.addEventListener('pageshow', function (event) {
    if (!event || !event.persisted) return;
    document.querySelectorAll('[data-vph-lightbox].is-open').forEach(function (node) {
      if (typeof node.__vskloPremiumClose === 'function') {
        try { node.__vskloPremiumClose(); } catch (error) {}
      } else {
        node.classList.remove('is-open');
        node.setAttribute('aria-hidden', 'true');
      }
    });
    document.documentElement.classList.remove('vsklo-premium-lightbox-open');
    if (document.body) document.body.classList.remove('vsklo-premium-lightbox-open');
  });
})();



(function () {
  'use strict';

  if (window.__VSKLO_PREMIUM_PRODUCT_HERO_DESCRIPTION__) return;
  window.__VSKLO_PREMIUM_PRODUCT_HERO_DESCRIPTION__ = true;

  function initDescriptionToggle(scope) {
    (scope || document)
      .querySelectorAll('[data-vph-description]')
      .forEach(function (description) {
        if (description.dataset.vphDescriptionReady === 'true') return;

        var text = description.querySelector(
          '[data-vph-description-text]'
        );

        var button = description.querySelector(
          '[data-vph-description-toggle]'
        );

        var moreLabel = description.querySelector(
          '[data-vph-description-more]'
        );

        var lessLabel = description.querySelector(
          '[data-vph-description-less]'
        );

        if (!text || !button || !moreLabel || !lessLabel) return;

        description.dataset.vphDescriptionReady = 'true';

        function isExpanded() {
          return description.classList.contains('is-expanded');
        }

        function isOverflowing() {
          return text.scrollHeight > text.clientHeight + 1;
        }

        function updateButton() {
          if (isExpanded()) {
            button.hidden = false;
            return;
          }

          button.hidden = !isOverflowing();
        }

        button.addEventListener('click', function () {
          var expanded = !isExpanded();

          description.classList.toggle('is-expanded', expanded);
          button.setAttribute(
            'aria-expanded',
            expanded ? 'true' : 'false'
          );

          moreLabel.hidden = expanded;
          lessLabel.hidden = !expanded;

          if (!expanded) {
            requestAnimationFrame(updateButton);
          }
        });

        requestAnimationFrame(updateButton);

        if ('ResizeObserver' in window) {
          var resizeObserver = new ResizeObserver(function () {
            updateButton();
          });

          resizeObserver.observe(text);
          description.__vskloDescriptionResizeObserver = resizeObserver;
        }
      });
  }

  function cleanupDescriptionsInScope(scope) {
    if (!scope) return;
    var descriptions = [];
    if (scope.matches && scope.matches('[data-vph-description]')) descriptions.push(scope);
    if (scope.querySelectorAll) {
      descriptions = descriptions.concat(Array.from(scope.querySelectorAll('[data-vph-description]')));
    }

    descriptions.forEach(function (description) {
      var observer = description.__vskloDescriptionResizeObserver;
      if (observer && typeof observer.disconnect === 'function') {
        try { observer.disconnect(); } catch (error) {}
      }
      delete description.__vskloDescriptionResizeObserver;
      description.removeAttribute('data-vph-description-ready');
    });
  }

  function boot(scope) {
    initDescriptionToggle(scope || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        boot(document);
      },
      { once: true }
    );
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    cleanupDescriptionsInScope(event && event.target ? event.target : null);
  });

  document.addEventListener('vsklo:content-updated', function (event) {
    var detail = event && event.detail ? event.detail : {};
    var scope =
      (detail.root && detail.root.querySelectorAll && detail.root) ||
      (detail.scope && detail.scope.querySelectorAll && detail.scope) ||
      document;
    boot(scope);
  });
})();
